// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"3e0c673e","411":"04809baa","535":"7f9f1c57","955":"04809baa","964":"050b219e","975":"04809baa"}[chunkId] + ".chunk.css";
};